require('./bootstrap');
// require('./heic2any');
window.$ = window.jQuery = require('jquery');
// window.$ = window.jQuery = require('jquery');

// flatpickr
import flatpickr from "flatpickr";
// flatpickr日本語化対応
import { Japanese } from "flatpickr/dist/l10n/ja.js"







// ---サイドメニュー関連---
var menu_btn = document.querySelector(".menu-btn");
var sidebar = document.querySelector("#sidebar");
var container = document.querySelector(".root-container");

var target = document.querySelectorAll('.menu-btn');
for (var i = 0; i < target.length; i++) {
    target[i].addEventListener('click', clickFunction, false);
}

function clickFunction(e) {
  sidebar.classList.toggle("active-nav");
  container.classList.toggle("active-cont");
  console.log("clickFunction")
}
// ---\サイドメニュー関連---



import {createApp} from 'vue/dist/vue.esm-bundler.js';
// import { heic2any } from 'heic2any/dist/heic2any.js';
import 'vue-universal-modal/dist/index.css'


const app = createApp({
    components: {
        'form-event-add-item': require('./components/form/EventAddItem.vue').default,
        'form-member-fee-itrem': require('./components/form/MemberFeeItrem.vue').default,
        'form-photo-image-upload': require('./components/form/PhotoImageUpload.vue').default,
        'form-profile-image-upload': require('./components/form/ProfileImageUpload.vue').default,
        'form-heic-to-any': require('./components/form/HeicToAny.vue').default,
    },
})
// import VueUniversalModal from 'vue-universal-modal'
// app.use(VueUniversalModal);


app.mount('#wrapper');
